import React from 'react';
import {
  Box,
  Typography,
  Paper,
  IconButton,
  Card,
  CardContent,
} from '@mui/material';
const SubjectsView = ({ subjects, onBack }) => {
  return (
    <Box sx={{ pb: 2 }}>
      <Box sx={{ p: 2, pb: 1 }}>
        <Typography variant="h6" fontWeight={700} gutterBottom>
          Subjects
        </Typography>
      </Box>

      <Box sx={{ px: 2 }}>
        {subjects.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body2" color="text.secondary">
              No subjects assigned yet
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
            {subjects.map((subject, idx) => (
              <Card
                key={subject.id || idx}
                sx={{
                  borderRadius: 2,
                  boxShadow: 1,
                }}
              >
                <CardContent>
                  <Typography variant="body1" fontWeight={600} sx={{ mb: 0.5 }}>
                    {subject.name}
                  </Typography>
                  {subject.teacher_name && (
                    <Typography variant="body2" color="text.secondary">
                      Teacher: {subject.teacher_name}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SubjectsView;

